export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.sideNavigations = payload

  return newState;
};
